var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunriseAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5303 4.46967C12.2374 4.17678 11.7626 4.17678 11.4697 4.46967L8.46967 7.46967C8.17678 7.76256 8.17678 8.23744 8.46967 8.53033C8.76256 8.82322 9.23744 8.82322 9.53033 8.53033L11.25 6.81066V11C11.25 11.4142 11.5858 11.75 12 11.75C12.4142 11.75 12.75 11.4142 12.75 11V6.81066L14.4697 8.53033C14.7626 8.82322 15.2374 8.82322 15.5303 8.53033C15.8232 8.23744 15.8232 7.76256 15.5303 7.46967L12.5303 4.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C9.49348 14 7.41774 15.8444 7.05588 18.25H2C1.58579 18.25 1.25 18.5858 1.25 19C1.25 19.4142 1.58579 19.75 2 19.75H22C22.4142 19.75 22.75 19.4142 22.75 19C22.75 18.5858 22.4142 18.25 22 18.25H16.9441C16.5823 15.8444 14.5065 14 12 14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1264 13.8735C16.8335 13.5806 16.8335 13.1057 17.1264 12.8128L18.5406 11.3986C18.8335 11.1057 19.3084 11.1057 19.6013 11.3986C19.8942 11.6915 19.8942 12.1664 19.6013 12.4593L18.1871 13.8735C17.8942 14.1664 17.4193 14.1664 17.1264 13.8735Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87356 12.8128C7.16645 13.1057 7.16645 13.5806 6.87356 13.8735C6.58067 14.1664 6.10579 14.1664 5.8129 13.8735L4.39869 12.4593C4.10579 12.1664 4.10579 11.6915 4.39869 11.3986C4.69158 11.1057 5.16646 11.1057 5.45935 11.3986L6.87356 12.8128Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunriseAlt1);
export default __webpack_public_path__ + "static/media/sunrise-alt-1.6c941a5dc10b35ae14328d6450174312.svg";
export { ForwardRef as ReactComponent };